var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFoto = function SvgFoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "foto_svg__Capa_2",
    viewBox: "0 0 47.92 47.92"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "foto_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.96,
    cy: 23.96,
    r: 23.96,
    fill: "#19d3c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 13.73h-1.95c-.73 0-1.42-.29-1.94-.8l-2.26-2.24c-.52-.51-1.21-.8-1.94-.8h-5.7c-.74 0-1.46.3-1.98.83l-2.1 2.16c-.52.53-1.23.83-1.98.83h-2.23c-1.52 0-2.76 1.24-2.76 2.76v15.68c0 1.52 1.24 2.76 2.76 2.76H35c1.52 0 2.76-1.24 2.76-2.76V16.47c0-1.52-1.24-2.76-2.76-2.76Z",
    fill: "#eafbf9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.96,
    cy: 23.96,
    r: 5.71,
    fill: "#19d3c5"
  }))));
};
export default SvgFoto;